import { ModalService } from './../services/modal.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SortablejsModule } from 'ngx-sortablejs';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgxSelectModule } from 'ngx-select-ex';
import { TreeviewModule } from 'ngx-treeview';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { TranslateModule } from '@ngx-translate/core';
import '../../../node_modules/chartjs-plugin-datalabels/dist/chartjs-plugin-datalabels.js';
import { InlineSVGModule } from 'ng-inline-svg';

import { SaveFormService } from '../services/save-form.service';
import { QuestionService } from '../services/question.service';
import { ProcessService } from '../services/process.service';
import { ProcessParticipationService } from '../services/process.participation.service';

import { FilterPipe } from '../pipes/filter.pipe';
import { BusinessUnitFilterPipe } from '../pipes/business-unit.filter.pipe';

import { MultipleDropdownComponent } from './multiple-dropdown/multiple-dropdown.component';
import { ModalDeleteComponent } from './modal/modal-delete/modal-delete.component';
import { ModalCreateComponent } from './modal/modal-create/modal-create.component';
import { ModalEditComponent } from './modal/modal-edit/modal-edit.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { DeleteRespondentComponent } from './modal/delete-respondent/delete-respondent.component';
import { AddRespondentComponent } from './modal/add-respondent/add-respondent.component';
import { AddBusinessUnitAdministratorComponent } from './modal/add-business-unit-administrator/add-business-unit-administrator.component';
import { DrillDownComponent } from './drilldown/drilldown.component';
import { EmployeeSelectionComponent } from './employee-selection/employee-selection.component';
import { SlimScroll } from '../directives/slimScroll/slimscroll.directive';
import { ReportComponent } from './reporting/report/report.component';
import { ConsolidatedTableComponent } from './reporting/report/table/consolidated-table.component';
import { DetailedTableComponent } from './reporting/report/table/detailed-table.component';
import { DetailedLinearTableComponent } from './reporting/report/table/detailed-linear-table.component';
import { DetailedMatrixTableComponent } from './reporting/report/table/detailed-matrix-table.component';
import { ReportingComponent } from './reporting/reporting.component';
import { UserAvatarComponent } from './user-avatar/user-avatar.component';
import { AppraiseeInfoModuleComponent } from './reporting/brief-report/appraisee-info-module/appraisee-info-module.component';
import { OverallRatingModuleComponent } from './reporting/brief-report/overall-rating-module/overall-rating-module.component';
import { SatisfactionRateModuleComponent } from './reporting/brief-report/satisfaction-rate-module/satisfaction-rate-module.component';
import { CommonReportResultComponent } from './reporting/brief-report/common-report-result/common-report-result.component';
import { RespondentsByGradeModuleComponent } from './reporting/brief-report/respondents-by-grade-module/respondents-by-grade-module.component';
import { RespondentsByCategoryModuleComponent } from './reporting/brief-report/respondents-by-category-module/respondents-by-category-module.component';
import { QuestionCategoriesRatingModuleComponent } from './reporting/brief-report/question-categories-rating-module/question-categories-rating-module.component';
import { StrongWeakSidesModuleComponent } from './reporting/brief-report/strong-weak-sides-module/strong-weak-sides-module.component';
import { ReportDescriptionModuleComponent } from './reporting/brief-report/report-description-module/report-description-module.component';
import { QuestionCategoriesDoughnutComponent } from './reporting/brief-report/question-categories-rating-module/question-categories-doughnut/question-categories-doughnut.component';
import { SatisfactionRateComponent } from './reporting/brief-report/satisfaction-rate-module/satisfaction-rate/satisfaction-rate.component';
import { TextQuestionsModuleComponent } from './reporting/brief-report/text-questions-module/text-questions-module.component';
import { DetailedReportFaqComponent } from './reporting/detailed-report/detailed-report-faq/detailed-report-faq.component';
import { CategoriesComponent } from './reporting/detailed-report/categories/categories.component';
import { CategoryQuestionComponent } from './reporting/detailed-report/categories/category-question/category-question.component';
import { QuestionScaleComponent } from './reporting/detailed-report/categories/category-question/question-scale/question-scale.component';
import { DeleteAppraiseeComponent } from './modal/delete-appraisee/delete-appraisee.component';
import { ReopenProcessModalComponent } from './modal/reopen-process-modal/reopen-process-modal.component';
import { DeadlineChangeModalComponent } from './modal/deadline-change-modal/deadline-change-modal.component';
import { ProcessTypeFeatureDirective } from '../directives/process-type-feature.directive';
import { TreeViewComponent } from './treeview/treeview.component';
import { TreeViewItemComponent } from './treeview/treeview-item/treeview-item.component';
import { TreeViewTemplateDirective } from './treeview/treeview-template.direcive';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ThankYouModalComponent } from './modal/thank-you-modal/thank-you-modal/thank-you-modal.component';
import { LoginComponent } from './login/login.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSelectModule,
    TranslateModule,
    TreeviewModule.forRoot(),
    CollapseModule.forRoot(),
    BsDropdownModule.forRoot(),
    AccordionModule.forRoot(),
    SortablejsModule,
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    TabsModule.forRoot(),
    InlineSVGModule.forRoot(),
    TooltipModule,
  ],
  declarations: [
    MultipleDropdownComponent,
    ModalDeleteComponent,
    ModalCreateComponent,
    ModalEditComponent,
    FilterPipe,
    BusinessUnitFilterPipe,
    SpinnerComponent,
    DeleteRespondentComponent,
    AddRespondentComponent,
    DrillDownComponent,
    AddBusinessUnitAdministratorComponent,
    EmployeeSelectionComponent,
    SlimScroll,
    ReportComponent,
    ConsolidatedTableComponent,
    DetailedTableComponent,
    DetailedLinearTableComponent,
    DetailedMatrixTableComponent,
    ReportingComponent,
    UserAvatarComponent,
    AppraiseeInfoModuleComponent,
    OverallRatingModuleComponent,
    SatisfactionRateModuleComponent,
    CommonReportResultComponent,
    RespondentsByGradeModuleComponent,
    RespondentsByCategoryModuleComponent,
    QuestionCategoriesRatingModuleComponent,
    StrongWeakSidesModuleComponent,
    ReportDescriptionModuleComponent,
    QuestionCategoriesDoughnutComponent,
    SatisfactionRateComponent,
    TextQuestionsModuleComponent,
    DetailedReportFaqComponent,
    CategoriesComponent,
    CategoryQuestionComponent,
    QuestionScaleComponent,
    DeleteAppraiseeComponent,
    ReopenProcessModalComponent,
    DeadlineChangeModalComponent,
    ProcessTypeFeatureDirective,
    TreeViewComponent,
    TreeViewItemComponent,
    TreeViewTemplateDirective,
    ThankYouModalComponent,
    LoginComponent
  ],
  entryComponents: [],
    exports: [
        MultipleDropdownComponent,
        ModalDeleteComponent,
        ModalCreateComponent,
        ModalEditComponent,
        FilterPipe,
        BusinessUnitFilterPipe,
        SpinnerComponent,
        DeleteRespondentComponent,
        AddRespondentComponent,
        DrillDownComponent,
        AddBusinessUnitAdministratorComponent,
        EmployeeSelectionComponent,
        SlimScroll,
        ReportingComponent,
        UserAvatarComponent,
        AccordionModule,
        InlineSVGModule,
        ReportDescriptionModuleComponent,
        TextQuestionsModuleComponent,
        DetailedReportFaqComponent,
        CategoriesComponent,
        CategoryQuestionComponent,
        QuestionScaleComponent,
        DeleteAppraiseeComponent,
        ReopenProcessModalComponent,
        ProcessTypeFeatureDirective,
        TreeViewComponent,
        TreeViewItemComponent,
        TreeViewTemplateDirective,
        ThankYouModalComponent,
        LoginComponent
    ],
  providers: [
    SaveFormService,
    QuestionService,
    ProcessService,
    ProcessParticipationService,
    ModalService,
    BusinessUnitFilterPipe,
  ],
})
export class FbtCommonModule {}
